"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEDULE_SLOT_TYPE = void 0;
var SCHEDULE_SLOT_TYPE;
(function (SCHEDULE_SLOT_TYPE) {
    SCHEDULE_SLOT_TYPE[SCHEDULE_SLOT_TYPE["ONLINE"] = 0] = "ONLINE";
    SCHEDULE_SLOT_TYPE[SCHEDULE_SLOT_TYPE["OFFLINE"] = 1] = "OFFLINE";
    SCHEDULE_SLOT_TYPE[SCHEDULE_SLOT_TYPE["HYBRID"] = 2] = "HYBRID";
})(SCHEDULE_SLOT_TYPE || (exports.SCHEDULE_SLOT_TYPE = SCHEDULE_SLOT_TYPE = {}));
